<template>
  <Row class="row-item" :class="{ 'row-start': flexStart, 'row-item-mini': mini, 'row-item-inline': inline }" :gutter="12">
    <Col :span="1" v-if="indent"><span>&nbsp;</span></Col>
    <Col :span="fieldSpan" class="col-item">
      <span v-if="label" class="item-field" :class="{ 'row-item-must': required }">{{ label }}</span>
    </Col>
    <Col :span="contentSpan">
      <slot></slot>
    </Col>
  </Row>
</template>
<script>
export default {
  name: 'rowItem',
  props: {
    label: {
      type: String
    },
    required: {
      type: Boolean,
      default() {
        return false
      }
    },
    prop: {
      type: String
    },
    flexStart: {
      type: Boolean,
      default() {
        return false
      }
    },
    mini: {
      type: Boolean,
      default: false
    },
    indent: {
      type: Boolean
    },
    inline: {
      type: Boolean
    }
  },
  computed: {
    fieldSpan() {
      return this.mini ? (this.label ? 8 : 0) : 5
    },
    contentSpan() {
      return this.mini ? (this.label ? 16 : 24) : 16
    }
  },
  inject: ['form']
}
</script>
<style lang="scss" scoped>
.row-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 24px;

  &.row-item-mini {
    margin-bottom: 10px;

    .item-field {
      font-size: 12px;
      padding-right: 0px;
    }
  }

  &.row-item-inline {
    position: absolute;
    z-index: 1;
    bottom: 6px;
    right: -118px;
    min-width: 524px;
  }

  .col-item {
    text-align: right;
  }

  i {
    margin-right: 4px;
    vertical-align: middle;

    &.ivu-icon-md-add {
      margin: 0;
    }
  }

  .item-field {
    font-size: 14px;
    padding-right: 12px;
  }

  /* 必填项 */
  .row-item-must {
    position: relative;
    z-index: 5;

    &:after {
      content: ' ';
      display: inline-block;
      width: 4px;
      height: 4px;
      position: absolute;
      top: 6px;
      right: 0;
      background-color: #f45858;
      border-radius: 3px;
    }
  }
}

.row-start {
  align-items: flex-start;

  .item-field {
    line-height: 32px;
  }
}
</style>
